module.exports = __webpack_public_path__ + "static/media/10.cad3a5fb.mp4";